import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { JournalEntryStatus } from "../types";

type StatusFilterValue = JournalEntryStatus | "" | "ALL";

interface JournalEntryFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  startDate: string;
  onStartDateChange: (value: string) => void;
  endDate: string;
  onEndDateChange: (value: string) => void;
  status: StatusFilterValue;
  onStatusChange: (value: StatusFilterValue) => void;
}

/**
 * Filter controls for journal entries list.
 */
export function JournalEntryFilters({
  search,
  onSearchChange,
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
  status,
  onStatusChange,
}: JournalEntryFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Search */}
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar por descripcion o referencia..."
          className="pl-9"
        />
      </div>

      {/* Date range */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground">Desde:</span>
        <Input
          type="date"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
          className="w-36"
        />
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground">Hasta:</span>
        <Input
          type="date"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
          className="w-36"
        />
      </div>

      {/* Status filter */}
      <Select
        value={status}
        onValueChange={(v) => onStatusChange(v as StatusFilterValue)}
      >
        <SelectTrigger className="w-[150px]">
          <SelectValue placeholder="Estado" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="ALL">Todos</SelectItem>
          <SelectItem value="DRAFT">Borrador</SelectItem>
          <SelectItem value="POSTED">Contabilizado</SelectItem>
          <SelectItem value="REVERSED">Anulado</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
